import { useSelector } from 'react-redux'
import {
  getIsDPMonthlySettlementEnabled,
  getIsTPMonthlySettlementEnabled,
} from '../BET_3937/use-monthly-state'

export default {
  useIsFullMonthlySettlementEnabled() {
    return useSelector(
      state =>
        getIsDPMonthlySettlementEnabled(state) &&
        getIsTPMonthlySettlementEnabled(state)
    )
  },
}
